import { useCMSPage } from "../../../context/CMSContext";

const DEFAULT_ITEMS = [
  { icon: "ri-leaf-line",       title: "Responsibility", desc: "Every load we collect is documented and disposed of legally." },
  { icon: "ri-heart-3-line",    title: "Care",           desc: "We treat your home and your belongings with respect." },
  { icon: "ri-bar-chart-line",  title: "Transparency",   desc: "Fixed prices, clear contracts, no hidden charges." },
  { icon: "ri-flashlight-line", title: "Speed",          desc: "Same-day where possible. We don't hang around." },
];

export default function AboutValues() {
  const { data: aboutCMS } = useCMSPage("about");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const valuesCMS: any = (aboutCMS as any)?.values ?? {};

  const headline = valuesCMS?.headline ?? "What we stand for.";
  const items    = valuesCMS?.items?.length ? valuesCMS.items : DEFAULT_ITEMS;

  return (
    <section className="py-20 bg-cl-tint">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
            <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Our Values</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight">{headline}</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item: { icon: string; title: string; desc: string }, i: number) => (
            <div key={i} className="bg-white rounded-2xl cartoon-card p-6 flex flex-col gap-4">
              <span className="w-12 h-12 flex items-center justify-center rounded-2xl bg-cl-lime border-2 border-cl-dark cartoon-shadow-sm">
                <i className={`${item.icon} text-cl-dark text-xl`}></i>
              </span>
              <div>
                <h3 className="font-black text-cl-dark text-lg mb-2">{item.title}</h3>
                <p className="text-cl-dark/65 text-sm font-semibold leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
